import Axios from "axios";
import React, {useEffect, useState} from "react";
import {useHistory} from "react-router-dom";
import {storage} from "../../utils";
// import {CKEditor} from "@ckeditor/ckeditor5-react";
// import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import {CKEditor} from "@ckeditor/ckeditor5-react";
import DecoupledEditor from "@ckeditor/ckeditor5-build-decoupled-document";
import {BlogImageUploadPlugin} from "../../utils/blogImageUpload";
import moment from "jalali-moment";
import DatePicker from "react-modern-calendar-datepicker";
import "react-modern-calendar-datepicker/lib/DatePicker.css";

const FormData = require("form-data");

const selectedDayFromDate = (value = new Date()) => ({
    year: Number(moment(value).locale("fa").format("YYYY")),
    month: Number(moment(value).locale("fa").format("M")),
    day: Number(moment(value).locale("fa").format("D")),
});

const publicationIso = (day, time) =>
    moment(
        `${day.year}/${String(day.month).padStart(2, "0")}/${String(day.day).padStart(2, "0")} ${time}`,
        "jYYYY/jMM/jDD HH:mm"
    ).toISOString();
// import "../../assets/css/plugins/forms/wizard.css";
// import ScriptTag from "react-script-tag";
// const Demo = (props) => (
//   <ScriptTag
//     type="text/javascript"
//     src="../../assets/js/scripts/forms/wizard-steps.js"
//   />
// );

// var fs = require("fs");
//locall
// import "./AddProduct.css";
import utils from "../../components/toastify/toastify";

const AddBlogPost = (props) => {
    const [title, setTitle] = useState("");
    const [short_title, set_short_title] = useState("");
    const [news_summary, set_news_summary] = useState("");
    const [content_img, set_content_img] = useState("");
    const [description, set_description] = useState("");
    const [slug, set_slug] = useState("");
    const [category_id, set_category_id] = useState("");
    const [categories, set_categories] = useState([]);
    const [publishedDay, setPublishedDay] = useState(() => selectedDayFromDate());
    const [publishedTime, setPublishedTime] = useState(() => moment().format("HH:mm"));

    let history = useHistory();

    useEffect(() => {
        storage.load("token").then((token) => {
            if (!token) return;
            Axios.get("/get_blog_categories", {headers: {"x-auth": token}})
                .then(({data}) => set_categories(data?.data || []))
                .catch(() => null);
        });
    }, []);

    const sendData = () => {
        var $white = "#fff";
        $.blockUI({
            message:
                '<div class="semibold"><span class="bx bx-reset icon-spin text-left align-middle" style="padding-bottom:1.75px"></span>&nbsp; در حال انجام عملیات ...</div>',

            // timeout: 2000, //unblock after 2 seconds
            overlayCSS: {
                backgroundColor: $white,
                opacity: 0.8,
                cursor: "wait",
            },
            css: {
                border: 0,
                padding: 0,
                backgroundColor: "transparent",
            },
        });

        const formData = new FormData();

        formData.append("logo_img", content_img);
        formData.append("description", description);
        formData.append("title", title);
        formData.append("short_title", short_title);
        formData.append("news_summary", news_summary);
        formData.append("slug", slug);
        formData.append("category_id", category_id);
        formData.append("published_at", publicationIso(publishedDay, publishedTime));

        storage.load("token").then((res) => {
            if (!res) return Promise.reject();
            Axios.post("/add_blog_post", formData, {
                headers: {
                    "x-auth": res,
                    "Content-Type": "multipart/form-data",
                },
            })
                .then((res) => {
                    $.unblockUI();
                    history.push("/dashboard/getBlogPosts");
                })
                .catch((err) => {
                    utils.showAlert("خطایی به وجود آمده است", "error");
                    $.unblockUI();
                });
        });
    };

    return (
        <div className="AddProductContainer">
            {/* <Wizard /> */}
            {/* <!-- Basic Inputs start --> */}
            <section id="basic-input">
                <div class="row">
                    <div class="col-md-12">
                        <div class="card">
                            <div class="card-header">
                                <h4 class="card-title">افزودن پست جدید</h4>
                            </div>

                            <div class="card">
                                {/* <div class="card-header">
                  <h4 class="card-title">ترم ها</h4>
                </div> */}
                                <div class="card-content">
                                    <div class="card-body">
                                        <form action="#" class="contact-repeater">
                                            <div data-repeater-list="contact">
                                                <div
                                                    class="row justify-content-between "
                                                    style={{minWidth: '100%'}}
                                                    data-repeater-item
                                                >
                                                    <div
                                                        style={{minWidth: '100%'}}
                                                        class="col-md-6 col-12 form-group d-flex align-items-center w-100">
                                                        <div
                                                            style={{
                                                                display: "flex",
                                                                flexDirection: "column",
                                                                width: "100%",
                                                            }}
                                                        >
                                                            <>
                                                                <h6>تیتر</h6>

                                                                <div
                                                                    style={{
                                                                        display: "flex",
                                                                        marginBottom: "10px",
                                                                    }}
                                                                >
                                                                    <input
                                                                        type="text"
                                                                        class="form-control"
                                                                        placeholder="تیتر"
                                                                        value={title}
                                                                        onChange={(e) => setTitle(e.target.value)}
                                                                    />
                                                                </div>
                                                                <h6>رو تیتر</h6>

                                                                <div
                                                                    style={{
                                                                        display: "flex",
                                                                        marginBottom: "10px",
                                                                    }}
                                                                >
                                                                    <input
                                                                        type="text"
                                                                        class="form-control"
                                                                        placeholder="رو تیتر"
                                                                        value={short_title}
                                                                        onChange={(e) =>
                                                                            set_short_title(e.target.value)
                                                                        }
                                                                    />
                                                                </div>

                                                                <h6>خلاصه خبر</h6>
                                                                <div
                                                                    style={{
                                                                        display: "flex",
                                                                        marginBottom: "10px",
                                                                    }}
                                                                >
                                                                    <textarea
                                                                        className="form-control"
                                                                        placeholder="خلاصه کوتاه خبر که زیر تصویر نمایش داده می‌شود"
                                                                        value={news_summary}
                                                                        maxLength={500}
                                                                        rows={3}
                                                                        onChange={(e) =>
                                                                            set_news_summary(e.target.value)
                                                                        }
                                                                    />
                                                                </div>

                                                                <h6>اسلاگ</h6>

                                                                <div
                                                                    style={{
                                                                        display: "flex",
                                                                        marginBottom: "10px",
                                                                    }}
                                                                >
                                                                    <input
                                                                        type="text"
                                                                        className="form-control"
                                                                        placeholder="اسلاگ"
                                                                        value={slug}
                                                                        onChange={(e) =>
                                                                            set_slug(e.target.value)
                                                                        }
                                                                    />
                                                                </div>

                                                                <h6>دسته‌بندی</h6>
                                                                <div style={{display: "flex", marginBottom: "10px"}}>
                                                                    <select className="form-control" value={category_id} onChange={(e) => set_category_id(e.target.value)}>
                                                                        <option value="">بدون دسته‌بندی</option>
                                                                        {categories.map((category) => <option key={category._id} value={category._id}>{category.name}</option>)}
                                                                    </select>
                                                                </div>

                                                                <h6>تاریخ و ساعت انتشار</h6>
                                                                <div style={{display: "flex", gap: "10px", alignItems: "center", marginBottom: "10px"}}>
                                                                    <DatePicker
                                                                        value={publishedDay}
                                                                        onChange={setPublishedDay}
                                                                        inputPlaceholder="انتخاب تاریخ انتشار"
                                                                        shouldHighlightWeekends
                                                                        locale="fa"
                                                                    />
                                                                    <input
                                                                        type="time"
                                                                        className="form-control"
                                                                        style={{maxWidth: "150px"}}
                                                                        value={publishedTime}
                                                                        onChange={(event) => setPublishedTime(event.target.value)}
                                                                        aria-label="ساعت انتشار"
                                                                    />
                                                                </div>

                                                                <div style={{marginTop: "10px"}}/>
                                                                <h6>توضیحات پست</h6>

                                                                <CKEditor
                                                                    onReady={(editor) => {
                                                                        console.log(
                                                                            "Editor is ready to use!",
                                                                            editor
                                                                        );
                                                                        // Insert the toolbar before the editable area.
                                                                        editor.ui
                                                                            .getEditableElement()
                                                                            .parentElement.insertBefore(
                                                                            editor.ui.view.toolbar.element,
                                                                            editor.ui.getEditableElement()
                                                                        );
                                                                    }}
                                                                    editor={DecoupledEditor}
                                                                    data={description}
                                                                    config={{
                                                                        language: "fa",
                                                                        extraPlugins: [BlogImageUploadPlugin],
                                                                    }}
                                                                    // onReady={(editor) => {
                                                                    //   // You can store the "editor" and use when it is needed.
                                                                    //   console.log(
                                                                    //     "Editor is ready to use!",
                                                                    //     editor
                                                                    //   );
                                                                    // }}
                                                                    onChange={(event, editor) => {
                                                                        const data = editor.getData();
                                                                        set_description(data);
                                                                    }}
                                                                    // onBlur={(event, editor) => {
                                                                    //   console.log("Blur.", editor);
                                                                    // }}
                                                                    // onFocus={(event, editor) => {
                                                                    //   console.log("Focus.", editor);
                                                                    // }}
                                                                />

                                                                {/*<CKEditor*/}
                                                                {/*    editor={ClassicEditor}*/}
                                                                {/*    data={description}*/}
                                                                {/*    config={{*/}
                                                                {/*        // Use the German language for this editor.*/}
                                                                {/*        language: "fa",*/}

                                                                {/*        // ...*/}
                                                                {/*    }}*/}
                                                                {/*    // onReady={(editor) => {*/}
                                                                {/*    //   // You can store the "editor" and use when it is needed.*/}
                                                                {/*    //   console.log(*/}
                                                                {/*    //     "Editor is ready to use!",*/}
                                                                {/*    //     editor*/}
                                                                {/*    //   );*/}
                                                                {/*    // }}*/}

                                                                {/*    onChange={(event, editor) => {*/}
                                                                {/*        const data = editor.getData();*/}
                                                                {/*        set_description(data);*/}
                                                                {/*    }}*/}
                                                                {/*    // onBlur={(event, editor) => {*/}
                                                                {/*    //   console.log("Blur.", editor);*/}
                                                                {/*    // }}*/}
                                                                {/*    // onFocus={(event, editor) => {*/}
                                                                {/*    //   console.log("Focus.", editor);*/}
                                                                {/*    // }}*/}
                                                                {/*/>*/}

                                                                {/* <div
                                    style={{
                                      display: "flex",
                                      marginBottom: "10px",
                                    }}
                                  >
                                    <input
                                      type="text"
                                      class="form-control"
                                      placeholder="عنوان محصول "
                                      value={property}
                                      onChange={(e) => set_property(e.target.value)}
                                    />
                                  </div> */}

                                                                <div class="row">
                                                                    <div class="col-md-6">
                                                                        <fieldset>
                                                                            <h6>اپلود تصویر</h6>
                                                                            <div class="input-group">
                                                                                <div class="input-group-prepend"></div>
                                                                                <div class="input-group">
                                                                                    <div class="custom-file">
                                                                                        <input
                                                                                            type="file"
                                                                                            class="custom-file-input"
                                                                                            id="inputGroupFile02"
                                                                                            onChange={(e) =>
                                                                                                set_content_img(
                                                                                                    e.target.files[0]
                                                                                                )
                                                                                            }
                                                                                        />
                                                                                        <label
                                                                                            class="custom-file-label"
                                                                                            for="inputGroupFile02"
                                                                                            aria-describedby="inputGroupFileAddon02"
                                                                                        >
                                                                                            {content_img
                                                                                                ? content_img.name
                                                                                                : "انتخاب فایل"}
                                                                                        </label>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </fieldset>
                                                                    </div>
                                                                </div>
                                                            </>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                            <button
                                onClick={() => {
                                    sendData();
                                }}
                                style={{
                                    marginTop: "-2rem",
                                    marginRight: "25px",
                                    width: "fit-content",
                                }}
                                type="button"
                                class="btn btn-success mr-1 mb-1 "
                            >
                                افزودن پست جدید
                            </button>
                        </div>
                    </div>
                </div>
            </section>
            {/* <!-- Basic Inputs end --> */}
            {/* <Demo /> */}
        </div>
    );
};

export {AddBlogPost};
